/**
 * Slice thousand integer and add `k` letter.
 *
 * @param {number} number - thousand integer
 * @return {string} a integer with letter
 */
export function sliceThousandInt(number) {
  return `${(number / 1000).toFixed(1)}k`;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-goodshare/src/helpers/count_number.js
// module id = 553
// module chunks = 1